import { useQuery } from '@tanstack/react-query'
import { getHeaders, handleErrors } from 'services/api/utils'
import { findOutWhichEnv, getEnvPath } from 'utils/env'

const env = findOutWhichEnv()
const BASE_PATH = `${getEnvPath(env)}/1.0/api`

function getSettings() {
  return fetch(`${BASE_PATH}/settings`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

const useGetSettings = () => {
  return useQuery({
    queryKey: ['get-settings'],
    queryFn: getSettings,
    select: (data) => data,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 2,
  })
}

export default useGetSettings
